export function wait(seconds: number) {
  return new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(void 0)
    }, seconds * 1000)
  })
}
